(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5508,2941,2403],{

/***/ 1950:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tomorrow-central",
      function () {
        return __webpack_require__(7649);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 3193:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Footer; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9815);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_future_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1608);
/* harmony import */ var next_future_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_future_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_data__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3449);
/* harmony import */ var _trust_DpiitBadge__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3856);






function Footer() {
    // Extra capabilities shown only in footer
    var footerOnlyCapabilities = [
        {
            name: "Agentic AI Servies & Solutions",
            link: "/services/agentic-ai"
        },
        {
            name: "AI Strategy For Business",
            link: "/outcomes"
        },
        {
            name: "Startup Solutions",
            link: "/startup"
        },
        {
            name: "Data Centre Readiness",
            link: "/services/data-center-project-readiness-governance"
        }, 
    ];
    // Combine both for footer — hub leads the Services group as the flagship practice
    var capabilitiesFooter = [
        {
            name: "Custom Software Development",
            link: "/services/custom-software-development"
        }, 
    ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_utils_data__WEBPACK_IMPORTED_MODULE_3__/* .capabilitiesNav */ .AQ), (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(footerOnlyCapabilities));
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("footer", {
            id: "contact-us",
            className: "bg-[#1e1e1e] text-center text-white px-[20px] md:px-[50px] mx-auto py-10",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "flex w-full items-center justify-between flex-wrap gap-4 md:w-[92%] mx-auto",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                            href: "/",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "mb-4 flex items-start text-2xl items-center cursor-pointer text-white hover:text-opacity-[0.7] font-bold mt-2",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "w-6 mr-2",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_future_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                            src: "/logo.png",
                                            alt: "logo",
                                            height: "51",
                                            width: "30"
                                        })
                                    }),
                                    "itmtb"
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_trust_DpiitBadge__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                            variant: "dark"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "grid grid-cols-2 md:grid-cols-5 gap-y-10 gap-x-10 my-8",
                    children: [
                        capabilitiesFooter,
                        _utils_data__WEBPACK_IMPORTED_MODULE_3__/* .industriesNav */ .xW,
                        productsNav,
                        generalPage,
                        contactLinks
                    ].map(function(navList, idx) {
                        var ref;
                        /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex flex-col space-y-2 items-start md:mx-auto",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "text-[20px] mb-1 font-semibold text-gray-100/40",
                                    children: ((ref = navList[0]) === null || ref === void 0 ? void 0 : ref.category) || (idx === 0 ? "Capabilities" : "")
                                }),
                                navList.map(function(item) {
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                        href: item.link,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                            target: item.link.includes("https:") ? "_blank" : "_self",
                                            rel: item.link.includes("https:") ? "noopener" : undefined,
                                            className: "text-left text-sm md:text-md hover:opacity-[0.6] cursor-pointer text-white",
                                            children: item.name
                                        })
                                    }, item.link);
                                })
                            ]
                        }, idx);
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "text-left my-10 sm:ml-4",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "text-gray-100/40",
                            children: "Locations"
                        }),
                        "Pune | Bhopal",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "text-gray-100/40",
                            children: "Email"
                        }),
                        "hello@itmtb.com"
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                    className: "text-sm",
                    children: [
                        "Copyright \xa9 ",
                        new Date().getFullYear(),
                        " Itmtb Technologies Private Limited"
                    ]
                })
            ]
        })
    });
};
// Footer-specific lists
var contactLinks = [
    {
        name: "Contact Us",
        link: "/contact-us",
        category: "Get in Touch"
    },
    {
        name: "LinkedIn",
        link: "https://www.linkedin.com/company/itmtb/"
    },
    {
        name: "Instagram",
        link: "https://www.instagram.com/itmtbtech/"
    }, 
];
var productsNav = [
    {
        name: "Orchestrik",
        link: "https://orchestrik.ai",
        category: "Products"
    },
    {
        name: "Tomorrow Central",
        link: "/tomorrow-central",
        category: "Products"
    },
    {
        name: "Enterprise Search",
        link: "/enterprise-search",
        category: "Products"
    }, 
];
var generalPage = [
    {
        name: "About Us",
        link: "/discover-itmtb",
        category: "Others"
    },
    {
        name: "Agents at Work",
        link: "/agents-at-work"
    },
    {
        name: "Privacy Policy",
        link: "/privacy_policy.html"
    },
    {
        name: "Careers",
        link: "/career"
    }, 
]; // import Link from "next/link";
 // import Image from "next/future/image";
 // import { capabilitiesNav, industriesNav } from "../utils/data";
 // export default function Footer() {
 //   return (
 //     <section>
 //       <footer id="contact-us" className="bg-[#1e1e1e] text-center text-white px-[20px] md:px-[50px] mx-auto py-10">
 //         <div className="flex w-full items-start md:w-[92%] mx-auto">
 //           <Link href="/">
 //             <div
 //               className="
 //             mb-4 flex items-start text-2xl items-center cursor-pointer text-white hover:text-opacity-[0.7] font-bold mt-2"
 //             >
 //               <div className="w-6 mr-2">
 //                 <Image src="/logo.png" alt="logo" height="51" width="30" />
 //               </div>
 //               itmtb
 //             </div>
 //           </Link>
 //         </div>
 //         <div className="grid grid-cols-2 md:grid-cols-4 gap-y-10 gap-x-10 my-8">
 //           {[capabilitiesNav, industriesNav, generalPage, contactLinks].map((navList, idx) => {
 //             return (
 //               <div key={idx} className="flex flex-col space-y-2 items-start md:mx-auto ">
 //                 <p className="text-[20px] mb-1 font-semibold text-gray-100/40">{navList[0].category}</p>
 //                 {navList.map(item => {
 //                   return (
 //                     <Link key={item.link} href={item.link}>
 //                       <a
 //                         target={item.link.includes("https:") ? "_blank" : "_self"}
 //                         className="text-left text-sm md:text-md hover:opacity-[0.6] cursor-pointer text-white"
 //                       >
 //                         {item.name}
 //                       </a>
 //                     </Link>
 //                   );
 //                 })}
 //               </div>
 //             );
 //           })}
 //         </div>
 //         <div className="text-left my-10 sm:ml-4">
 //           <p className="text-gray-100/40">Locations</p>
 // 		  Pune | Mumbai | Bhopal
 //           <p className="text-gray-100/40">Email</p>
 // 	 hello@itmtb.com
 //         </div>
 //         <p className="text-sm">Copyright © {new Date().getFullYear()} Itmtb Technologies Private Limited</p>
 //       </footer>
 //     </section>
 //   );
 // }
 // const contactLinks = [
 //   {
 //     name: "Contact Us",
 //     link: "/contact-us",
 //     category: "Get in Touch",
 //   },
 //   {
 //     name: "LinkedIn",
 //     link: "https://www.linkedin.com/company/itmtb/",
 //   },
 //   {
 //     name: "Instagram",
 //     link: "https://www.instagram.com/itmtbtech/",
 //   },
 // ];
 // const generalPage = [
 //   {
 //     name: "About Us",
 //     link: "/discover-itmtb",
 //     category: "Others",
 //   },
 //   {
 //     name: "Privacy Policy",
 //     link: "/privacy_policy.html",
 //   },
 //   {
 //     name: "Careers",
 //     link: "/career",
 //   },
 // ];


/***/ }),

/***/ 3856:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ DpiitBadge; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_future_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1608);
/* harmony import */ var next_future_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_future_image__WEBPACK_IMPORTED_MODULE_1__);


// DPIIT / Startup India recognition credential — single source of truth for
// every placement (footer, about page, homepage trust strip).
//
// Uses the official DPIIT + #startupindia recognition logo supplied by the
// Startup India programme (ITMTB is a recognised startup). The logo carries the
// national emblem + wordmarks, so it sits on a white chip to stay legible on any
// surface (including the dark footer). The recognition number is the extra
// verifiable fact the logo itself does not carry.
var RECOGNITION_NO = "DIPP274362";
var LOGO_SRC = "/dpiit-startupindia.webp";
var LOGO_W = 1969;
var LOGO_H = 655;
function DpiitBadge(param) {
    var _variant = param.variant, variant = _variant === void 0 ? "light" : _variant, _bare = param.bare, bare = _bare === void 0 ? false : _bare, _className = param.className, className = _className === void 0 ? "" : _className;
    var logoHeight = variant === "dark" ? "h-7" : "h-9";
    var chrome = bare ? "" : "rounded-lg border border-gray-200 bg-white px-4 py-2.5 shadow-sm";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "inline-flex items-center gap-3 ".concat(chrome, " ").concat(className),
        "aria-label": "Recognised by DPIIT under the Startup India initiative, recognition number ".concat(RECOGNITION_NO),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_future_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                src: LOGO_SRC,
                alt: "Recognised by DPIIT — Startup India",
                width: LOGO_W,
                height: LOGO_H,
                className: "".concat(logoHeight, " w-auto shrink-0")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "h-8 w-px bg-gray-200 shrink-0",
                "aria-hidden": "true"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "leading-tight text-left",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "text-[10px] font-semibold uppercase tracking-wider text-gray-400",
                        children: "Recognised"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                        className: "text-sm font-semibold text-gray-900",
                        children: [
                            "Reg. No. ",
                            RECOGNITION_NO
                        ]
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 7649:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ TomorrowCentralPage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(5791);
/* harmony import */ var lucide_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9828);
/* harmony import */ var lucide_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1864);
/* harmony import */ var lucide_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(6309);
/* harmony import */ var lucide_react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(2701);
/* harmony import */ var _components_Footer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3193);






var Navbar = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(2684), __webpack_require__.e(7804), __webpack_require__.e(867)]).then(__webpack_require__.bind(__webpack_require__, 7804));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(7804)
            ];
        }
    },
    ssr: false
});

var TC_URL = "https://tomorrowcentral.com";
var VIOLET = "#7c3aed";
var WHAT = [
    {
        Icon: lucide_react__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z,
        title: "Free, self-serve tools",
        desc: "Point-and-run tools like Cloud Cost Sentinel — sign in, connect a scoped role you can revoke anytime, and get evidence-backed results. Many are free forever."
    },
    {
        Icon: lucide_react__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z,
        title: "Two front doors",
        desc: "Every tool is a console your team can click and an MCP server your agents can call — same auth, same results. Built for people and agents."
    },
    {
        Icon: lucide_react__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z,
        title: "Part of the itmtb ecosystem",
        desc: "Tomorrow Central is how itmtb ships free, self-serve tools. When a tool isn't enough, the same team builds custom software for you."
    }, 
];
function TomorrowCentralPage() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "bg-white",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: "Tomorrow Central — self-serve tools for infra, tech & agents | itmtb"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: "Tomorrow Central is itmtb's self-serve tools platform — free tools for infra, tech and agents, where every tool ships a UI for people and an MCP server for agents."
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "canonical",
                        href: "https://itmtb.com/tomorrow-central"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Navbar, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                className: "bg-[#1B6B93]",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "mx-auto max-w-[1600px] w-[90%] md:w-[85%] pt-[110px] pb-[70px] md:pt-[130px] md:pb-[90px]",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(framer_motion__WEBPACK_IMPORTED_MODULE_8__/* .motion.div */ .E.div, {
                        initial: {
                            opacity: 0,
                            y: 24
                        },
                        animate: {
                            opacity: 1,
                            y: 0
                        },
                        transition: {
                            duration: 0.6,
                            ease: [
                                0.22,
                                1,
                                0.36,
                                1
                            ]
                        },
                        className: "max-w-3xl",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "text-white/70 text-sm font-semibold uppercase tracking-widest mb-4",
                                children: "itmtb \xb7 Product"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                className: "text-4xl sm:text-5xl md:text-6xl font-bold text-white leading-[1.05] tracking-tight mb-5",
                                children: "Tomorrow Central"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "text-white/85 text-lg md:text-xl leading-relaxed max-w-2xl mb-9",
                                children: "The tech stack for agents and people — self-serve tools for infra, tech and agents. Free to start, with a UI your team can click and an MCP server your agents can call."
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex flex-col sm:flex-row gap-4",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                        href: TC_URL,
                                        target: "_blank",
                                        rel: "noopener noreferrer",
                                        className: "inline-flex items-center justify-center gap-2 rounded-md px-7 py-3.5 text-sm font-semibold text-white transition-opacity hover:opacity-90",
                                        style: {
                                            backgroundColor: VIOLET
                                        },
                                        children: [
                                            "Explore the tools ",
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(lucide_react__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                                size: 16
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                        href: "".concat(TC_URL, "/developers"),
                                        target: "_blank",
                                        rel: "noopener noreferrer",
                                        className: "inline-flex items-center justify-center gap-2 rounded-md border border-white/40 px-7 py-3.5 text-sm font-semibold text-white transition-colors hover:bg-white/10",
                                        children: "For agents (MCP)"
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                className: "bg-white",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "mx-auto max-w-[1600px] w-[90%] md:w-[85%] py-16 md:py-24",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                            className: "text-3xl md:text-4xl font-bold text-slate-900 tracking-tight mb-3",
                            children: "What Tomorrow Central is"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "text-slate-500 text-lg max-w-2xl mb-12",
                            children: "A growing catalogue of focused tools you can run yourself — no infrastructure to manage."
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "grid grid-cols-1 md:grid-cols-3 gap-6",
                            children: WHAT.map(function(param) {
                                var Icon = param.Icon, title = param.title, desc = param.desc;
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "rounded-2xl border border-slate-200 p-7 hover:border-[#1B6B93]/40 transition-colors",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "w-12 h-12 rounded-xl bg-[#1B6B93]/10 flex items-center justify-center mb-5",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Icon, {
                                                size: 24,
                                                className: "text-[#1B6B93]",
                                                strokeWidth: 1.75
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                            className: "text-lg font-semibold text-slate-900 mb-2",
                                            children: title
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "text-slate-500 leading-relaxed",
                                            children: desc
                                        })
                                    ]
                                }, title);
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                className: "bg-slate-50 border-t border-slate-100",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "mx-auto max-w-[1600px] w-[90%] md:w-[85%] py-16 md:py-20",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex flex-col lg:flex-row lg:items-center lg:justify-between gap-8",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "max-w-2xl",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                        className: "text-2xl md:text-3xl font-bold text-slate-900 tracking-tight mb-3",
                                        children: "From the team at itmtb."
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "text-slate-500 text-lg leading-relaxed",
                                        children: "Tomorrow Central is where itmtb ships free, self-serve tools. If you need more than a tool — a private deployment, an integration, or software built for your business — itmtb builds it."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex flex-col sm:flex-row gap-4 shrink-0",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                        href: TC_URL,
                                        target: "_blank",
                                        rel: "noopener noreferrer",
                                        className: "inline-flex items-center justify-center gap-2 rounded-md px-7 py-3.5 text-sm font-semibold text-white transition-opacity hover:opacity-90",
                                        style: {
                                            backgroundColor: VIOLET
                                        },
                                        children: [
                                            "Explore Tomorrow Central ",
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(lucide_react__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                                size: 16
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                                        href: "/contact-us",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                            className: "inline-flex items-center justify-center gap-2 rounded-md border border-slate-300 px-7 py-3.5 text-sm font-semibold text-slate-700 transition-colors hover:border-slate-400",
                                            children: "Talk to itmtb"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Footer__WEBPACK_IMPORTED_MODULE_4__["default"], {})
        ]
    });
};


/***/ }),

/***/ 3449:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AQ": function() { return /* binding */ capabilitiesNav; },
/* harmony export */   "xW": function() { return /* binding */ industriesNav; },
/* harmony export */   "zR": function() { return /* binding */ categoriesData; },
/* harmony export */   "zr": function() { return /* binding */ badgeMapper; }
/* harmony export */ });
/* unused harmony exports capabilities, careerData, careerLookingFor */
var capabilities = (/* unused pure expression or super */ null && ([
    "Cloud",
    "Cyber Security",
    "Data and Artificial Intelligence",
    "Enterprise Applications and Automation",
    "IoT and Digital Engineering",
    "Managed Services",
    "Marketing & Experience",
    "Quality Engineering",
    "Strategy",
    "Sustainability",
    "Talent & Learning",
    "Technology Consulting", 
]));
var capabilitiesNav = [
    {
        name: "Cloud",
        link: "/services/cloud",
        category: "Capabilities"
    },
    {
        name: "Cyber Security",
        link: "/services/cybersecurity"
    },
    {
        name: "AI Agents & Automation",
        link: "/services/analytics-ai-automation"
    },
    {
        name: "Forward Deployed Engineering",
        link: "/services/forward-deployed-engineering"
    },
    {
        name: "Enterprise Applications and Automation",
        link: "/services/enterprise-applications"
    },
    {
        name: "IoT and Digital Engineering",
        link: "/services/iot-and-digital-eng"
    },
    {
        name: "Managed Services",
        link: "/services/managed-services"
    },
    {
        name: "Quality Engineering",
        link: "/services/quality-engineering"
    },
    {
        name: "Strategy",
        link: "/services/strategy"
    },
    {
        name: "Technology Consulting",
        link: "/services/technology-consulting"
    },
    {
        name: "Tech Stack Audit",
        link: "/services/tech-stack-audit"
    }, 
];
var industriesNav = [
    {
        name: "Banking",
        link: "/industry/banking",
        category: "Industries"
    },
    {
        name: "Insurance",
        link: "/industry/insurance"
    },
    {
        name: "Life Sciences",
        link: "/industry/life-sciences"
    },
    {
        name: "Retail",
        link: "/industry/retail"
    },
    {
        name: "Supply Chain",
        link: "/industry/supply-chain"
    }, 
];
var badgeMapper = function(badge) {
    if (badge === "case-study") return "Success Story";
    return "Insight";
};
var careerData = [
    {
        point: "1. Solve awesome problems",
        pointText: "Whether it is technology, strategy, sales, or marketing, interesting problems find us",
        desc: "From increasing operational efficiency by 400x, to designign the most scalable cloud architecture, to rewriting algorithms to process faster in real time, all the way to discovering the right business strategies for the customer, we do it all.",
        linkText: "Success Stories",
        link: "/blog/success-stories",
        img: "/career/career - technlogies.webp"
    },
    {
        point: "2. Work across industries",
        pointText: "Our universe is truly parallel. Which one would you like?",
        desc: " Be it D2C retail, supply chain, pharma and life sciences, fintech and more, you get to expose yourself to an unparalleled diversity of business problems.",
        linkText: "",
        link: "",
        img: "/career/career - diverse industries.webp"
    },
    {
        point: "3. Have a little fun while you do it",
        pointText: "Road trips, anyone?",
        desc: "Enjoy not just the grind but also the unwinds. From unplanned road-trips to goofy ittle things, we’ve got the spirit to make every day at work ridiculously entertaining.",
        linkText: "",
        link: "",
        img: "/career/career - fun.webp"
    }, 
];
var careerLookingFor = [
    {
        title: "You must love solving problems",
        desc: "Problems excite no one. Solutions excite everyone. But only a few are willing to put their backs into finding a solution while the rest give up. You are not 'the rest.'"
    },
    {
        title: "Technology is just another toolkit in your bag",
        desc: "Can you only solve a problem if its within your skills. What do you do when needed to learn something new and deliver quickly?"
    },
    {
        title: "You must understand the value of helping your mates",
        desc: " Remember a leading runner slowing down to help his fallen competitor? Would you slow down if you knew your team mate really needed your help?"
    }, 
];
var categoriesData = [
    {
        title: "Design",
        desc: "Change is the only constant. Reinvent your business with the right strategy and technology implementations."
    },
    {
        title: "Build",
        desc: "Technology is often the key differentiator. Get the technology you need to lead the competition."
    },
    {
        title: "Improve",
        desc: "Right quality and mature operations hold the key to cost efficiency. Rediscover them."
    },
    {
        title: "Protect",
        desc: "It is important to build. It is even more imporant to protect. Safeguard your digital assets."
    }, 
]; // {
 //     "slug": "",
 //     "metaDesc": "",
 //     "metaKeyword": "",
 //     "image": "",
 //     "paragraph": "",
 //     "heading": "",
 //     "mainHeading": "",
 //     "numbers": [
 //         {
 //             "number": "",
 //             "detail": ""
 //         },
 //     ],
 //     "details": {
 //         "title": "",
 //         "summary": "",
 //         "listItems": [
 //             "",
 //         ]
 //     },
 //     "points": [
 //         {
 //             "key": "",
 //             "title": "",
 //             "text": ""
 //         },
 //     ],
 //     "whyChooseUs": ""
 // }


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1608,5791,6845,9774,2888,179], function() { return __webpack_exec__(1950); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);